import { render } from "./ReasonsInvest.vue?vue&type=template&id=4cc5dede&scoped=true"
import script from "./ReasonsInvest.vue?vue&type=script&lang=js"
export * from "./ReasonsInvest.vue?vue&type=script&lang=js"

import "./ReasonsInvest.vue?vue&type=style&index=0&id=4cc5dede&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cc5dede"

export default script